import React, { useState } from 'react';
import { packageData } from '../data/packageData';
import PackageModal from '../components/PackageModal';

const Gallery = () => {
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  const filteredPackages = Object.values(packageData).filter(package_ => {
    const searchLower = searchQuery.toLowerCase();
    return (
      package_.name.toLowerCase().includes(searchLower) ||
      package_.description.toLowerCase().includes(searchLower) ||
      package_.items.some(item => 
        item.name.toLowerCase().includes(searchLower)
      )
    );
  });

  return (
    <div className="min-h-screen pt-20 bg-gray-50">
      {/* Gallery Banner */}
      <div className="bg-aqua-600 text-white py-24">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-playfair font-bold mb-4">Event Packages</h1>
          <p className="text-xl max-w-3xl mx-auto mb-8">
            Choose from our carefully curated packages designed for your special occasions
          </p>
          {/* Search Bar */}
          <div className="max-w-xl mx-auto">
            <input
              type="text"
              placeholder="Search packages by name, description, or items..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full px-4 py-2 rounded-lg border-2 border-white bg-white/10 text-white placeholder-white/70 focus:outline-none focus:border-gold-500"
            />
          </div>
        </div>
      </div>

      {/* Packages Grid */}
      <div className="container mx-auto px-4 py-8">
        {filteredPackages.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-gray-600 text-lg">No packages found matching "{searchQuery}"</p>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {filteredPackages.map((package_) => (
              <div
                key={package_.id}
                className="bg-white rounded-md shadow overflow-hidden cursor-pointer transition-transform duration-300 hover:transform hover:scale-105"
                onClick={() => setSelectedPackage(package_)}
              >
                <div className="relative pb-[75%]">
                  <img
                    src={package_.mainImage}
                    alt={package_.name}
                    className="absolute inset-0 w-full h-full object-cover object-center"
                  />
                  <div className="absolute top-2 right-2">
                    <span className="bg-gold-500 text-white px-2 py-1 rounded-full text-sm font-medium">
                      ZMW {package_.price}
                    </span>
                  </div>
                </div>
                <div className="p-3">
                  <h3 className="text-lg font-playfair font-bold text-gray-900 mb-1">
                    {package_.name}
                  </h3>
                  <p className="text-gray-600 text-sm mb-2 line-clamp-2">
                    {package_.description}
                  </p>
                  <div className="flex flex-wrap gap-1">
                    {package_.items.slice(0, 2).map((item, index) => (
                      <span
                        key={index}
                        className="bg-gray-100 text-gray-600 text-xs px-2 py-0.5 rounded-full"
                      >
                        {item.name}
                      </span>
                    ))}
                    {package_.items.length > 2 && (
                      <span className="bg-gray-100 text-gray-600 text-xs px-2 py-0.5 rounded-full">
                        +{package_.items.length - 2} more
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Package Modal */}
      {selectedPackage && (
        <PackageModal
          package={selectedPackage}
          onClose={() => setSelectedPackage(null)}
        />
      )}
    </div>
  );
};

export default Gallery;